/*
 * Author: harper
 * File Created: Friday, 23-07-14 03:40 pm
 * Last Modified: Thursday, 25-07-17 03:19 pm, by Dw
 * Copyright © 2023 - Liberty MIT
 */
'use client';

import { createTheme } from '@mui/material';
import type { ThemeOptions } from '@mui/material/styles';

import { MuiBreadcrumbs } from './breadcrumbs';
import Buttons from './button';
import { MuiCheckbox } from './checkbox';
import { MuiDrawer } from './darwer';
import { MuiDialog } from './dialog';
import List from './list';
import { MuiRadio } from './radio';
import { MuiSnackbar } from './snackbar';
import {
  MuiStepConnector,
  MuiStepIcon,
  MuiStepLabel,
  MuiStepper,
} from './stepper';
import { Tabs } from './tabs';
import { MuiTextField } from './text-field';
import { MuiTypography } from './typography';

const themeOptions: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#7E61F3',
      dark: '#5844AA',
      light: '#BFB0F9',
    },
    secondary: {
      main: '#FFFFFF',
    },
    warning: {
      main: '#EF9C40',
    },
    success: {
      main: '#0CBD88',
    },
    error: {
      main: '#CF304A',
    },
    text: {
      primary: '#EAECEF',
      secondary: '#848E9C',
      disabled: '#4F5867',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 905,
      lg: 1200,
      xl: 1440,
    },
  },
  components: {
    MuiTypography,
    MuiLink: {
      defaultProps: {
        underline: 'none',
      },
    },
    ...Buttons,
    MuiContainer: {
      defaultProps: {
        disableGutters: false,
      },
    },
    MuiTextField,
    MuiOutlinedInput: {
      defaultProps: {
        notched: false,
      },
    },
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
    },
    MuiSnackbar,
    MuiDialog,
    MuiBreadcrumbs,
    MuiRadio,
    MuiDrawer,
    MuiCheckbox,
    MuiStepConnector,
    MuiStepIcon,
    MuiStepLabel,
    MuiStepper,
    ...List,
    ...Tabs,
  },
};

const theme = createTheme(themeOptions);

export default theme;
